import React from 'react';

const footerLinks = {
  services: [
    { label: 'B2B Content Syndication', href: 'https://itmunch.com/b2b-content-syndication-services/', external: true },
    { label: 'B2B Lead Generation', href: 'https://itmunch.com/b2b-lead-generation-services/', external: true },
    { label: 'E-mail Marketing', href: 'https://itmunch.com/email-marketing-services/', external: true },
    { label: 'Enterprise SEO', href: 'https://itmunch.com/enterprise-seo-services/', external: true },
    { label: 'Meta Advertising', href: 'https://itmunch.com/meta-advertising-services/', external: true },
    { label: 'Programmatic Advertising', href: 'https://itmunch.com/programmatic-advertising-services/', external: true },
    { label: 'AI Agent Services', href: 'https://itmunch.com/ai-agent-for-sales/', external: true },
    { label: 'Backlink Services', href: 'https://backlink.itmunch.com/', external: true },
  ],
  aboutUs: [
    { label: 'About iTMunch', href: 'https://itmunch.com/about/', external: true },
    { label: 'Blog', href: 'https://itmunch.com/', external: true },
    { label: 'Send Us Your Story', href: 'https://itmunch.com/send-us-your-story/', external: true },
    { label: 'Privacy Policy', href: 'https://itmunch.com/privacy-policy/', external: true },
  ],
  contactUs: [
    { label: 'Book a Call', href: 'https://calendly.com/simon-p-itmunch/30min', external: true },
    { label: 'Get Started', href: '#hero' },
    { label: 'FAQ', href: '#faq' },
  ],
  partners: [
    { label: 'Whitepapers Online', href: 'https://whitepapersonline.com/', external: true },
    { label: 'ToolsMetric', href: 'https://toolsmetric.com/', external: true },
  ],
};

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="bg-slate-900 border-t border-slate-800"
      role="contentinfo"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {/* Logo + Description Row */}
        <div className="flex flex-col md:flex-row items-start md:items-center gap-6 mb-12 pb-10 border-b border-slate-800">
          <a href="#hero" className="shrink-0" data-testid="footer-logo">
            <img
              src="https://itmunch.com/wp-content/uploads/2021/01/ITT-MUNCH_LOGO-4-1-1024x512_800x400.webp"
              alt="iTMunch - Where Technology Meets You"
              className="h-20 w-auto object-contain"
            />
          </a>
          <div className="md:ml-4">
            <p className="text-sm text-slate-400 leading-relaxed max-w-md">
              Leading B2B content syndication service provider, helping enterprises generate qualified leads across 1,500+ platforms.
            </p>
          </div>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Services */}
          <div className="col-span-2">
            <h3 className="font-['Outfit'] text-sm font-semibold text-slate-300 uppercase tracking-wide mb-4">
              Services
            </h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="text-sm text-slate-400 hover:text-[#4AC5DB] transition-colors"
                    {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* About Us */}
          <div>
            <h3 className="font-['Outfit'] text-sm font-semibold text-slate-300 uppercase tracking-wide mb-4">
              About Us
            </h3>
            <ul className="space-y-3">
              {footerLinks.aboutUs.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="text-sm text-slate-400 hover:text-[#4AC5DB] transition-colors"
                    {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li className="pt-3">
                <h3 className="font-['Outfit'] text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">
                  Partner Websites
                </h3>
                <ul className="space-y-2">
                  {footerLinks.partners.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                        className="text-sm text-slate-400 hover:text-[#4AC5DB] transition-colors"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="font-['Outfit'] text-sm font-semibold text-slate-300 uppercase tracking-wide mb-4">
              Contact Us
            </h3>
            <ul className="space-y-3">
              {footerLinks.contactUs.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                    className="text-sm text-slate-400 hover:text-[#4AC5DB] transition-colors"
                    {...(link.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            &copy; {new Date().getFullYear()} iTMunch. All rights reserved.
          </p>
          <p className="text-sm text-slate-500">
            B2B Content Syndication Service Provider
          </p>
        </div>
      </div>
    </footer>
  );
}
